import {
  Box,
  Button,
  IconButton,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DashboardSearch from '../../../components/DashboardComponents/DashboardSearch';
import { useThemes } from '../../../components/Theme/theme';
import { ArrowDropDown, ArrowRight, Circle, Delete, Edit } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { flattenTree, handleFreeze, searchInAccountList, searchInAccountTree } from '../../../utils/common';
import { MoneyFormatv3 } from '../../../library/MoneyFormat';
import CreateAndEditLedger from '../../../components/modals/CreateAndEditLedger';
import AddNewPartyModal from '../../PrimeFigma/Modals/AddNewPartyModal';
import { getPartyMasterAccountWiseCustom, getPartyMasterCustom } from '../../../graphql';
import { API, graphqlOperation } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { settingsClose } from '../../../redux/reducers/companySkipSave';
import CreateAndEditGroupModal from '../../../components/modals/CreateAndEditGroupModal';
import AddPNFSales from '../../../components/modals/AddPNFSales';
import AddPNFPurchase from '../../../components/modals/AddPNFPurchase';
import AddPNFCreditNote from '../../../components/modals/AddPNFCreditNote';
import AddPNFJournal from '../../../components/modals/AddPNFJournal';
import AddPNFDebitNote from '../../../components/modals/AddPNFDebitNote';
import AddBalanceSheetPayment from '../../../components/modals/AddBalanceSheetPayment';
import AddBalanceSheetReceipt from '../../../components/modals/AddBalanceSheetReceipt';
import DeleteLedgerGroup from '../../../components/modals/DeleteLedgerGroup';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useDeleteAccountGroupMasterMutation } from '../../../redux/apis/accountGroupMaster.api';
import { useDeleteAccountMasterMutation } from '../../../redux/apis/accountMaster.api';
import { dashboardApi } from '../../../redux/apis/dashboardApi';
import VoucherBTNnew from '../../../components/Buttons/VoucherBTNnew';
import { useVirtualizer, useWindowVirtualizer } from '@tanstack/react-virtual';
import ActionButtons from '../../../components/Buttons/ActionButtons';

const commonStyle = {
  rowHeight: 45,
  fontSize: 15,
};

const buttonStyle = {
  borderRadius: 10,
  color: '#297179',
  backgroundColor: '#FFF',
  fontFamily: 'overpass',
  fontWeight: '700',
  fontSize: 15,
  paddingTop: 0.5,
  paddingBottom: 0.5,
  PaddingLeft: 1,
  paddingRight: 1,
  marginBottom: 1,
};

function ReceivablesTable({
  heading,
  rows,
  setNewLedgerResponse,
  newLedgerAccountID,
  setAccountID,
  expandButtonClicked,
  refetchDb,
  hideZeroledger,
  hideGroup,
}) {
  const { theme } = useThemes();

  const [expandedRows, setExpandedRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [groupName, setGroupName] = useState('');
  const [partyDetails, setPartyDetails] = useState(null);
  const [deleteId, setdeleteId] = useState('');
  const [searchText, setSearchText] = useState('');
  const [sortby, setSortBy] = useState('all');
  const [data, setData] = useState([]);
  const [newPartyID, setNewPartyID] = useState(null);
  const [autoExpand, setAutoExpand] = useState([]);

  const [openModal, setOpenModal] = useState({
    groupModal: false,
    ledgerModal: false,
    editModal: false,
    partyModal: false,
    editGroupModal: false,
    deleteModal: false,
    transcationModal: false,
    receiptModal: false,
    journalModal: false,
    paymentModal: false,
    debitNoteModal: false,
    creditNoteModal: false,
    salesModal: false,
    purchaseModal: false,
  });

  const matches = useMediaQuery('(max-width:600px)');

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    const openModalBasedOnSelection = async () => {
      setGroupName(selectedRow.id);
      if (selectedRow?.modal === 'group' && selectedRow?.category === 'group') {
        handleOpenModal('groupModal');
      }
      if (selectedRow?.modal === 'ledger') {
        if (selectedRow?.action === 'edit') {
          const partyMasterResponse = await fetchPartyMasterData(selectedRow.id);
          setPartyDetails(partyMasterResponse);
          handleOpenModal('ledgerModal');
        } else {
          const segments = selectedRow.path.split('/');
          const partyType = segments.includes('7') ? 'SUPPLIER' : 'CUSTOMER';
          setPartyDetails({
            partytypecd: partyType,
          });
          handleOpenModal('ledgerModal');
        }
      }
      if (selectedRow?.modal === 'deleteModal') {
        handleOpenModal('deleteModal');
      }
    };

    if (selectedRow) {
      if (saveSkipStatus == false && typeof selectedRow == 'object') {
        dispatch(settingsClose());
        navigate('/companysetup');
      } else {
        openModalBasedOnSelection();
      }
    }
  }, [selectedRow]);

  useEffect(() => {
    let filteredRows = [...rows];

    // Apply search & sort filter
    if ((searchText && sortby) || sortby !== 'all') {
      let searchResult = searchInAccountList(filteredRows, searchText, sortby);
      filteredRows = flattenTree(searchResult);
    }

    // Apply hide zero ledger filter
    if (hideZeroledger) {
      filteredRows = filteredRows.filter((item) => item.category === 'group' || item?.balance !== 0);
    }

    setData(filteredRows);

    //  expanded groups
    const expanded = filteredRows.filter((row) => row.category === 'group').map((row) => ({ id: row.id, isExpand: true }));

    setExpandedRows(expanded);
  }, [rows, hideZeroledger, searchText, sortby]);

  useEffect(() => {
    if (deleteId !== '') {
      deleteLedgers();
    }
  }, [deleteId]);

  useEffect(() => {
    if (newLedgerAccountID?.length > 0) {
      setAutoExpand((prevItems) => {
        const lastID = newLedgerAccountID?.at(-1);
        if (!prevItems.some((item) => item.id === lastID)) {
          return [...prevItems, { id: lastID, expand: false }];
        }
        return prevItems;
      });
    }
  }, [newLedgerAccountID]);

  const memoizedRows = useMemo(() => data, [data]);

  const [maxSize, setMaxSize] = useState(0);
  const [balanceArray, setBalanceArray] = useState([]);

  useEffect(() => {
    function getMaxTextWidth(textArray, font = '16px Roboto') {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      context.font = font;

      let maxWidth = 0;

      textArray.forEach((text) => {
        const str = String(text ?? ''); // always a string (even if null or undefined)
        const { width } = context.measureText(str);
        if (width > maxWidth) {
          maxWidth = `${width + 100}px`;
        }
      });

      return maxWidth;
    }

    if (!memoizedRows || memoizedRows.length === 0) {
      setMaxSize('0px');
      return;
    }
    const balanceArray = memoizedRows.map((item) => item?.balance ?? '');
    const width = getMaxTextWidth(balanceArray, '16px Roboto');

    console.log(width, '==> computed width');

    setMaxSize(width);
  }, [memoizedRows]);

  useEffect(() => {
    const expandAncestors = (row, autoExpand) => {
      if (autoExpand.some((item) => item.id === row._id && !item.expand)) {
        setAutoExpand((prev) => prev.map((item) => (item.id === row._id ? { ...item, expand: true } : item)));
        setExpandedRows((prev) => {
          if (!prev.includes(row._id)) {
            return [...prev, row._id];
          }
          return prev;
        });

        return true;
      }

      if (row.children) {
        for (let child of row.children) {
          if (expandAncestors(child, autoExpand)) {
            setExpandedRows((prev) => {
              if (!prev.includes(row._id)) {
                return [...prev, row._id];
              }
              return prev;
            });
            return true;
          }
        }
      }
      return false;
    };

    memoizedRows.forEach((row) => {
      if (autoExpand.length > 0) {
        if (expandAncestors(row, autoExpand)) {
          setExpandedRows((prev) => {
            if (!prev.includes(row._id)) {
              return [...prev, row._id];
            }
            return prev;
          });
        }
      }
    });
  }, [memoizedRows, autoExpand]);

  useEffect(() => {
    if (rows?.length > 0) {
      if (expandButtonClicked) {
        handleExpandAll();
      } else {
        handleCollapseAll();
      }
    }
  }, [expandButtonClicked]);

  useEffect(() => {
    if (newPartyID) findNewPartyAccountId();
  }, [newPartyID]);

  async function findNewPartyAccountId() {
    try {
      const response = await API.graphql(
        graphqlOperation(getPartyMasterCustom, {
          partyid: newPartyID,
        })
      );
      if (selectedRow?.action === 'create') {
        setNewLedgerResponse(response?.data?.getPartyMaster[0]?.accountsid + 'ledger');
      } else {
        setNewLedgerResponse(null);
      }

      refetchDb && refetchDb();
      setNewPartyID(null);
    } catch (error) {
      console.error('Error fetching new party account data:', error);
    }
  }

  const handleOpenModal = (key) => {
    if (key in openModal) {
      setOpenModal((prev) => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const toggleExpandRow = useCallback(
    (id) => {
      setData((prevRows) => {
        let result = [...prevRows];
        const isExpand = expandedRows.find((ele) => ele.id === id)?.isExpand || false;
        if (isExpand) {
          result = prevRows.filter(
            (item) => !item.path?.split('/')?.includes(String(id)) || (item?.id === id && item.category === 'group')
          );
          const collapseIDs = data
            .filter((item) => item?.path?.split('/')?.includes(String(id)) && item.category === 'group')
            .map((item) => item?.id);
          setExpandedRows((prev) => prev.map((row) => (collapseIDs.includes(row.id) ? { ...row, isExpand: false } : row)));
        } else {
          // Expand Logic
          const forFilter = hideZeroledger ? rows.filter((item) => item.category === 'group' || item.balance !== 0) : rows;

          const filteredData = forFilter.filter((item) => item.parent === id);
          const index = result.findIndex((item) => item?.id === id);
          if (index !== -1) {
            result.splice(index + 1, 0, ...filteredData);
          } else {
            result = [...result, ...filteredData];
          }
          setExpandedRows((prev) => prev.map((row) => (row.id === id ? { ...row, isExpand: true } : row)));
        }
        return result;
      });
    },
    [expandedRows, rows]
  );

  const [deleteAccountGroupMaster] = useDeleteAccountGroupMasterMutation();
  const [deleteAccountMaster] = useDeleteAccountMasterMutation();

  async function deleteLedgers() {
    if (deleteId.category === 'group') {
      try {
        const response = await deleteAccountGroupMaster({
          accountgroupid: deleteId.id,
        });

        if (response.data !== null) {
        }

        if (response?.data?.statuscode === 'Error') {
          showWarningSnackbar(response?.data?.statusmessage);
        } else {
          showSuccessSnackbar('Group Deleted');
        }
      } catch (error) {
        showErrorSnackbar(error.message);
        console.error('Error deleting group:', error);
      }
    }
    if (deleteId.category === 'ledger') {
      try {
        const response = await deleteAccountMaster({ accountsid: deleteId.id });
        let { statuscode, statusmessage } = response.data;
        if (statuscode === 'Error') {
          if (statusmessage.includes('Transactions Already Recorded')) {
            showWarningSnackbar('Cannot delete ledger account : Transactions exists in the current year');
          } else {
            showErrorSnackbar(statusmessage);
          }
        } else {
          showSuccessSnackbar('Ledger Deleted');
        }
      } catch (error) {
        showErrorSnackbar('Something went wrong.please try again.');
      } finally {
        setdeleteId('');
        dispatch(dashboardApi.util.invalidateTags(['dashboard']));
      }
    }
  }

  const fetchPartyMasterData = async (AccountsID) => {
    try {
      const response = await API.graphql(
        graphqlOperation(getPartyMasterAccountWiseCustom, {
          accountsid: AccountsID,
        })
      );

      return response?.data?.getPartyMasterAccountWise[0];
    } catch (error) {
      console.error('Error fetching party master account data:', error);
      throw error;
    }
  };

  const handleExpandAll = () => {
    const filteredData = hideZeroledger ? rows.filter((item) => item.category === 'group' || item?.balance !== 0) : rows;
    setExpandedRows(filteredData.filter((row) => row.category === 'group').map((row) => ({ id: row.id, isExpand: true })));
    setData(filteredData);
  };

  const handleCollapseAll = () => {
    setExpandedRows(rows.filter((row) => row.category === 'group').map((row) => ({ id: row.id, isExpand: false })));
    const collapseData = data.filter((item) => item.category === 'group' && [15, 7].includes(item.id));
    setData(collapseData);
  };

  const listRef = React.useRef(null);
  // Virtualizer setup
  const rowVirtualizer = useWindowVirtualizer({
    count: memoizedRows.length,
    estimateSize: () => 35,
    overscan: 50,
    scrollMargin: listRef.current?.offsetTop ?? 0,
  });

  const handleTranscationModal = useCallback((category, id) => {
    if (id === 25) {
      navigate('/?active=ProfitAndLoss');
      return;
    }
    if (category === 'ledger') {
      setAccountID(id);
    }
  }, []);

  const handleSelectRow = useCallback((row, modal) => {
    setSelectedRow(row);
    handleOpenModal(modal);
  }, []);

  return (
    <>
      <Box ref={listRef} sx={{ boxSizing: 'border-box', minWidth: 'fit-content' }}>
        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              width: '80%',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              backgroundColor: `${theme.palette.primary.main}  !important`,
              borderRight: '4px solid',
              borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? '#26262F' : '#ffffff',
              '.button-container': {
                display: 'none',
              },
              '.hover-default': {
                display: 'none',
              },
              '&:hover': {
                '.button-container': {
                  display: 'block',
                },
                '.hover-default': {
                  display: 'block',
                },
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                px: 2,
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="h1" sx={{ color: '#ffff', fontSize: { xs: 14, lg: 16 } }}>
                {heading}
              </Typography>
              <DashboardSearch searchText={searchText} setSearchText={setSearchText} sortby={sortby} setSortBy={setSortBy} />
            </Box>
          </Box>
          <Box
            sx={{
              minWidth: '20%',
              width: { xs: maxSize, xl: '20%' },
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
              backgroundColor: `${theme.palette.primary.main}  !important`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h1" sx={{ color: '#ffff', fontSize: { xs: 14, lg: 16 } }}>
              Amount
            </Typography>
          </Box>
        </Box>

        <Box sx={{ border: '1px solid #C0C0C0' }}>
          <Box
            sx={{
              height: `${rowVirtualizer.getTotalSize()}px`,
              position: 'relative',
            }}
          >
            {rowVirtualizer.getVirtualItems().map((virtualRow) => {
              const item = memoizedRows[virtualRow.index];
              const isExpand = expandedRows.find((ele) => ele.id === item?.id)?.isExpand || false;
              return (
                <div
                  key={virtualRow.key}
                  ref={virtualRow.measureRef}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: `${virtualRow.size}px`,
                    borderBottom: '1px solid rgb(218, 217, 217)',
                    transform: `translateY(${virtualRow.start - rowVirtualizer.options.scrollMargin}px)`,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <Box
                      sx={{
                        width: '80%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderRight: '4px solid ',
                        borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
                        '.button-container': {
                          display: 'none',
                        },
                        '.hover-default': {
                          display: 'none',
                        },
                        '&:hover': {
                          '.button-container': {
                            display: 'block',
                          },
                          '.hover-default': {
                            display: matches ? 'none' : 'block',
                          },
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingLeft: `${(item.path.split('/').length - 5 + 2) * 10}px`,
                          maxWidth: matches ? '180px' : '80%',
                          whiteSpace: 'nowrap',
                          overflow: 'scroll',
                          // textOverflow: "ellipsis",
                          scrollbarWidth: 'none',
                          '&::-webkit-scrollbar': {
                            display: 'none',
                          },
                        }}
                      >
                        {item?.category === 'group' ? (
                          <IconButton
                            aria-label={isExpand ? 'collapse' : 'expand'}
                            size="small"
                            onClick={() => toggleExpandRow(item?.id)}
                            style={{ padding: 0, margin: 0 }}
                          >
                            {isExpand ? <ArrowDropDown /> : <ArrowRight />}
                          </IconButton>
                        ) : (
                          <IconButton size="small" style={{ padding: 0, margin: 0 }}>
                            <Circle
                              sx={{
                                width: 10,
                                height: 10,
                                color: '#ee5b2b',
                                marginRight: 1.5,
                                marginLeft: 1.75,
                              }}
                            />
                          </IconButton>
                        )}
                        <Typography
                          onClick={item?.category === 'ledger' ? () => handleTranscationModal(item?.category, item.id) : undefined}
                          sx={{
                            cursor: item?.category === 'ledger' ? 'pointer' : 'default',
                            fontSize: { xs: 11, lg: 13 },
                            fontWeight: item?.category === 'group' ? 'bold' : 0,
                            color:
                              item?.category === 'group'
                                ? theme.palette.primary.main
                                : theme?.palette?.TmId.id.toString().includes('9')
                                ? '#fff'
                                : '#000000',
                          }}
                        >
                          <Tooltip title={item?.name}>{item?.name}</Tooltip>
                        </Typography>
                        {item?.restrictedflag === 1 && (
                          <Typography
                            className="hover-default"
                            textAlign="center"
                            variant="body2"
                            fontStyle="italic"
                            sx={{ px: 1, color: '#818694' }}
                          >
                            {item?.category === 'ledger' ? 'Default A/C' : 'Default Group'}
                          </Typography>
                        )}

                        {newLedgerAccountID === (item?.category === 'group' ? item?.id : item?._id) && (
                          <Box
                            sx={{
                              backgroundColor: '#FF004D',
                              color: '#FFF',
                              borderRadius: 10,
                              marginLeft: 1.5,
                              fontSize: 10,
                              paddingLeft: 2,
                              paddingRight: 2,
                              paddingTop: 0.25,
                              paddingBottom: 0.25,
                            }}
                          >
                            New
                          </Box>
                        )}
                      </Box>

                      <ActionButtons
                        key={virtualRow?.index}
                        item={item}
                        handleSelectRow={handleSelectRow}
                        Freeze={Freeze}
                        theme={theme}
                        bgcolor={theme.palette.primary.main}
                      />
                    </Box>
                    <Box
                      sx={{
                        minWidth: '20%',
                        width: { xs: maxSize, xl: '20%' },
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                      }}
                    >
                      {(!hideGroup || item?.category === 'ledger') && (
                        <Typography
                          sx={{
                            px: 1,
                            fontSize: { xs: 11, lg: 13 },
                            fontWeight: item?.category === 'group' ? 'bold' : 0,
                            color:
                              item?.category === 'group'
                                ? theme.palette.primary.main
                                : theme?.palette?.TmId.id.toString().includes('9')
                                ? '#fff'
                                : '#000000',
                          }}
                        >
                          ₹ {MoneyFormatv3(item.balance)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </div>
              );
            })}
          </Box>
        </Box>
      </Box>

      {/* <Table aria-label="recursive table">
        <TableHead
          sx={{
            backgroundColor: `${theme.palette.primary.main}  !important`,
          }}
        >
          <TableCell
            sx={{
              backgroundColor: "primary.main",
              borderTopRightRadius: 10,
              borderTopLeftRadius: 10,
              padding: "20px 0",
              color: "#818694",
              borderTopRightRadius: 15,
              borderRight: "4px solid",
              borderRightColor: theme?.palette?.TmId.id
                .toString()
                .includes("9")
                ? "#1e1e1e"
                : "white",
            }}
          >
            <Box>
              <div
                style={{
                  width: "100%",
                  color: "#FFF",
                  letterSpacing: 1,
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: 15,
                  fontFamily: "overpass",
                  fontSize: 15,
                }}
              >
                <span style={{ paddingLeft: "10px" }}>{heading}</span>
                <DashboardSearch searchText={searchText} setSearchText={setSearchText} sortby={sortby} setSortBy={setSortBy} />
              </div>
            </Box>
          </TableCell>
          <TableCell
            sx={{
              backgroundColor: "primary.main",
              borderTopRightRadius: 10,
              borderTopLeftRadius: 10,
              position: "relative",
              borderTopLeftRadius: 15,
              borderLeft: "4px solid ",
              borderLeftColor: theme?.palette?.TmId.id
                .toString()
                .includes("9")
                ? "#1e1e1e"
                : "white",
            }}
          >
            <Box>
              <div
                style={{
                  width: "100%",
                  color: "#FFF",
                  // fontSize: 13,
                  // fontWeight: '700',
                  letterSpacing: 1,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 15,
                  fontFamily: "overpass",
                  fontSize: 15,
                }}
              >
                <span>Amount</span>
              </div>
            </Box>
          </TableCell>
        </TableHead>
        <TableBody sx={{
          ".MuiTableCell-root": {
            backgroundColor: "transparent !important",
          },
        }}>
          {data?.length ? data?.map((row) => (
            <RecursiveTableRow
              key={row?.id}
              row={row}
              expandedRows={expandedRows}
              toggleExpandRow={toggleExpandRow}
              commonStyle={commonStyle}
              setSelectedRow={setSelectedRow}
              setGroupName={setGroupName}
              setOpenModal={(e) => handleOpenModal(e)}
              newLedgerAccountID={newLedgerAccountID}
              hideGroup={hideGroup}
              hideZeroLedger={hideZeroLedger}
              setAccountID={setAccountID}
            />
          )) :
            <TableRow>
              <TableCell rowSpan={5} colSpan={3} sx={{ textAlign: "center" }}>
                No Data Found
              </TableCell>
            </TableRow>
          }



        </TableBody>
      </Table> */}
      {openModal.ledgerModal && (
        <AddNewPartyModal
          open={openModal.ledgerModal}
          setOpen={(e) => handleOpenModal('ledgerModal')}
          partyType={
            partyDetails?.partytypecd == 'SUPPLIER' ? 'supplier' : partyDetails?.partytypecd == 'CUSTOMER' ? 'customer' : 'Add Party'
          }
          Type={'Party'}
          setNewPartyID={(newId) => setNewPartyID(newId)}
          setPartyType={() => {}}
          partyGroupId={selectedRow.category === 'group' ? selectedRow.id : selectedRow.parent}
          page="Receivable"
          partyParamsID={partyDetails?.partyid}
          newPartyName={partyDetails?.partyid ? selectedRow?.name : ''}
        />
      )}

      {openModal.groupModal && (
        <CreateAndEditGroupModal
          open={openModal.groupModal}
          setOpen={() => handleOpenModal('groupModal')}
          groupId={groupName}
          action={selectedRow?.action}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
          setNewLedgerResponse={setNewLedgerResponse}
          page={'Dashboard'}
          tab={heading}
        />
      )}

      <DeleteLedgerGroup
        open={openModal.deleteModal}
        setOpen={() => handleOpenModal('deleteModal')}
        setdeleteId={setdeleteId}
        selectedRow={selectedRow}
        setsuccessSnakbar={showSuccessSnackbar}
      />

      <AddPNFSales open={openModal.salesModal} setOpen={() => handleOpenModal('salesModal')} />
      <AddPNFPurchase open={openModal.purchaseModal} setOpen={() => handleOpenModal('purchaseModal')} />
      <AddPNFCreditNote open={openModal.creditNoteModal} setOpen={() => handleOpenModal('creditNoteModal')} />
      <AddPNFJournal open={openModal.journalModal} setOpen={() => handleOpenModal('journalModal')} />
      <AddPNFDebitNote open={openModal.debitNoteModal} setOpen={() => handleOpenModal('debitNoteModal')} />
      <AddBalanceSheetPayment open={openModal.paymentModal} setOpen={() => handleOpenModal('debitNoteModal')} groupName={groupName} />
      <AddBalanceSheetReceipt
        open={openModal.receiptModal}
        setOpen={() => handleOpenModal('receiptModal')}
        groupName={groupName}
        selectedRow={selectedRow}
      />
    </>
  );
}

export default ReceivablesTable;

const RecursiveTableRow = ({
  row,
  level = 0,
  expandedRows,
  toggleExpandRow,
  commonStyle,
  setSelectedRow,
  setGroupName,
  setCreateGroupModal,
  setOpenModal,
  newLedgerAccountID,
  hideGroup,
  hideZeroLedger,
  setAccountID,
}) => {
  const { theme } = useThemes();

  const isExpanded = expandedRows.includes(row?.id);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  return (
    <>
      {hideZeroLedger && row?.balance === 0 && row.category === 'ledger' ? (
        ''
      ) : (
        <TableRow
          style={{
            height: commonStyle.rowHeight,
            p: 0,
            borderLeft: '1px solid #C0C0C0',
            borderRight: '1px solid #C0C0C0',
          }}
        >
          <TableCell
            component="th"
            scope="row"
            sx={{
              padding: 0,
              margin: 0,
              maxWidth: '250px',
              borderRight: '4px solid ',
              borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#eef0f0',
              '.button-container': {
                display: 'none',
              },
              '.hover-default': {
                display: 'none',
              },
              '&:hover': {
                '.button-container': {
                  display: 'block',
                },
                '.hover-default': {
                  display: 'block',
                },
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Stack direction="row">
                <Box
                  sx={{
                    paddingLeft: `${level * 10}px`,
                    maxWidth: '200px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: commonStyle.fontSize,
                    cursor: row.category === 'ledger' ? 'pointer' : 'default',
                    color:
                      row?.category === 'group'
                        ? 'primary.main'
                        : row?.name === 'Net Loss'
                        ? '#d40217'
                        : theme?.palette?.TmId.id.toString().includes('9')
                        ? '#fff'
                        : '#000000',
                    fontWeight: row?.category === 'group' ? 'bold' : '',
                  }}
                  onClick={row?.category === 'ledger' ? () => setAccountID(row?.id) : undefined}
                >
                  {row?.category === 'group' ? (
                    <IconButton
                      aria-label={isExpanded ? 'collapse' : 'expand'}
                      size="small"
                      onClick={() => toggleExpandRow(row?.id)}
                      style={{ padding: 0, margin: 0 }}
                    >
                      {isExpanded ? <ArrowDropDown /> : <ArrowRight />}
                    </IconButton>
                  ) : (
                    <IconButton size="small" onClick={() => toggleExpandRow(row?.id)} style={{ padding: 0, margin: 0 }}>
                      <Circle
                        sx={{
                          width: 10,
                          height: 10,
                          color: '#ee5b2b',
                          marginRight: 1.5,
                          marginLeft: 1.75,
                        }}
                      />
                    </IconButton>
                  )}
                  <Tooltip title={row?.name}>{row?.name}</Tooltip>
                </Box>
                {row?.restrictedflag === 1 && (
                  <Typography
                    className="hover-default"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      marginLeft: 0.5,
                      color: '#818694',
                    }}
                    textAlign="center"
                    variant="body2"
                    fontStyle="italic"
                  >
                    {row?.category === 'ledger' ? 'Default A/C' : 'Default Group'}
                  </Typography>
                )}
                {newLedgerAccountID?.includes(row?._id) && (
                  <Box
                    sx={{
                      backgroundColor: '#FF004D',
                      color: '#FFF',
                      borderRadius: 10,
                      marginLeft: 1.5,
                      fontSize: 10,
                      paddingLeft: 2,
                      paddingRight: 2,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                    }}
                  >
                    New
                  </Box>
                )}
              </Stack>
              <Box sx={{ paddingRight: '10px', display: 'flex' }}>
                {row?.restrictedflag != 1 && row?.id !== 40 && (
                  <>
                    <Tooltip title={`Delete ${row.category}`} placement="bottom">
                      <button
                        className="button-container"
                        style={{
                          border: 0,
                          backgroundColor: theme.palette.shadow.secondary,
                          width: 25,
                          height: 25,
                          borderRadius: 4,
                          marginLeft: 10,
                          cursor: 'pointer',
                          boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                          alignItems: 'center',
                        }}
                        onClick={() => {
                          if (Freeze == 1) {
                            return handleFreeze();
                          }
                          setSelectedRow(row);
                          setOpenModal('deleteModal');
                          // setDeleteModal(true);
                        }}
                      >
                        <Delete fontSize="large" sx={{ fontSize: '15px', color: '#fafafb' }} />
                      </button>
                    </Tooltip>
                    <Tooltip EditTooltip title={`Edit ${row?.category}`} placement="bottom">
                      <button
                        className="button-container"
                        style={{
                          border: 0,
                          backgroundColor: theme.palette.secondary.main,
                          width: 25,
                          height: 25,
                          borderRadius: 4,
                          cursor: 'pointer',
                          boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                          marginLeft: 10,
                        }}
                        onClick={() => {
                          if (Freeze == 1) {
                            return handleFreeze();
                          }
                          let newRow = {
                            ...row,
                            action: 'edit',
                            modal: row.category === 'group' ? 'group' : 'ledger',
                          };
                          setSelectedRow(newRow);
                          setGroupName(row?.id);
                          // setUpdateModal(true);
                        }}
                      >
                        <Edit fontSize="large" sx={{ fontSize: '15px', color: '#fafafb' }} />
                      </button>
                    </Tooltip>
                  </>
                )}
                {row.category === 'group' && row?.id !== 25 ? (
                  <>
                    <button
                      className="G"
                      style={{
                        border: 0,
                        backgroundColor: theme.palette.primary.main,
                        width: 25,
                        height: 25,
                        borderRadius: 4,
                        boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                        marginLeft: 10,
                      }}
                      onClick={() => {
                        if (Freeze == 1) {
                          return handleFreeze();
                        }
                        let newRow = {
                          ...row,
                          action: 'create',
                          modal: 'group',
                        };
                        setSelectedRow(newRow);
                        setGroupName(row.id);
                      }}
                    >
                      <Tooltip title="New Group" placement="bottom">
                        <Box
                          sx={{
                            fontSize: '14px',
                            color: '#fff',
                            fontWeight: 'bold',
                            backgroundColor: 'primary.main',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          G
                        </Box>
                      </Tooltip>
                    </button>
                    <button
                      className="L"
                      style={{
                        border: 0,
                        backgroundColor: theme.palette.secondary.main,
                        width: 25,
                        height: 25,
                        borderRadius: 4,
                        boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                        marginLeft: 10,
                      }}
                      onClick={() => {
                        if (Freeze == 1) {
                          return handleFreeze();
                        }
                        let newRow = {
                          ...row,
                          action: 'create',
                          modal: 'ledger',
                        };
                        setSelectedRow(newRow);
                        setGroupName(row.id);
                        // // setPadding(paddLeft)
                      }}
                    >
                      <Tooltip title="New Ledger" placement="bottom">
                        <Box
                          sx={{
                            fontSize: '14px',
                            color: '#fff',
                            fontWeight: 'bold',
                            backgroundColor: 'secondary.main',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          L
                        </Box>
                      </Tooltip>
                    </button>
                    <button
                      className="V"
                      style={{
                        border: 0,
                        backgroundColor: theme.palette.bodyGray.tertiary,
                        width: 25,
                        height: 25,
                        borderRadius: 4,
                        marginLeft: 10,
                      }}
                    >
                      <Box
                        sx={{
                          fontSize: '14px',
                          color: '#d1d8ed',
                          fontWeight: 'bold',
                          backgroundColor: 'bodyGray.tertiary',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        V
                      </Box>
                    </button>
                  </>
                ) : (
                  row.id !== 40 && (
                    <>
                      <button
                        style={{
                          border: 0,
                          backgroundColor: theme.palette.bodyGray.tertiary,
                          width: 25,
                          height: 25,
                          borderRadius: 4,
                          marginLeft: 10,
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: '14px',
                            color: '#d1d8ed',
                            fontWeight: 'bold',
                            backgroundColor: 'bodyGray.tertiary',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          G
                        </Box>
                      </button>
                      <button
                        style={{
                          border: 0,
                          backgroundColor: theme.palette.bodyGray.tertiary,
                          width: 25,
                          height: 25,
                          borderRadius: 4,
                          marginLeft: 10,
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: '14px',
                            color: '#d1d8ed',
                            fontWeight: 'bold',
                            backgroundColor: 'bodyGray.tertiary',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          L
                        </Box>
                      </button>
                      <VoucherBTNnew key={row?.id} item={row} />
                    </>
                  )
                )}
              </Box>
            </Box>
          </TableCell>
          <TableCell
            align="right"
            style={{
              padding: 0,
              margin: 0,
              paddingRight: '5px',
              fontSize: commonStyle.fontSize,
              color:
                row?.category === 'group'
                  ? theme.palette.primary.main
                  : theme?.palette?.TmId.id.toString().includes('9')
                  ? '#fff'
                  : '#000000',
              fontWeight: row?.category === 'group' ? 'bold' : '',
            }}
          >
            {hideGroup && row?.category === 'group' ? '' : '₹ ' + MoneyFormatv3(row?.balance)}
          </TableCell>
          {/* Example data */}
        </TableRow>
      )}

      {isExpanded &&
        row?.children &&
        row?.children.length > 0 &&
        row?.children.map((child) => (
          <RecursiveTableRow
            key={child.id}
            row={child}
            level={level + 1}
            expandedRows={expandedRows}
            toggleExpandRow={toggleExpandRow}
            commonStyle={commonStyle}
            setSelectedRow={setSelectedRow}
            setGroupName={setGroupName}
            setCreateGroupModal={setCreateGroupModal}
            setOpenModal={setOpenModal}
            newLedgerAccountID={newLedgerAccountID}
            hideGroup={hideGroup}
            hideZeroLedger={hideZeroLedger}
            setAccountID={setAccountID}
          />
        ))}
    </>
  );
};
